import { Modal, SafeAreaView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonView } from "../../components/ButtonView";
import { color_333333 } from "../../assets/style/colors";
import { Str_Cancel, Str_EmailRetrieve, Str_PhoneRetrieve, Str_SecurityRetrieve } from "../../language/string_res";

type ForgotPsgModalProps = {
    visible: boolean;
    boundTelno: boolean
    boundEmail: boolean
    boundSecurity: boolean
    dismiss: () => void;
    navForgotPsd: (type:number) => void;

};
export const ForgotPsgModal = (props: ForgotPsgModalProps) => {
    const { visible, dismiss, boundEmail, boundSecurity, boundTelno,navForgotPsd } = props;
    const Line = () =>
        (<View style={{ backgroundColor: "#F1F1F1", height: 0.5, marginHorizontal: 9 }} />)


    return (<Modal
        animationType="fade"
        transparent={true}
        statusBarTranslucent={true}
        visible={visible}
        onRequestClose={dismiss}>
        <TouchableOpacity
            style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.5)" }}
            activeOpacity={1}
            onPress={dismiss}>
            <SafeAreaView
                style={styles.modalContainer}>
                {boundSecurity && <ButtonView
                    style={styles.modalItemContainer}
                    textStyle={styles.modalText}
                    text={Str_SecurityRetrieve}
                    onPress={() => navForgotPsd(1)}
                />}
                {boundTelno && <Line />}
                {boundTelno && <ButtonView
                    style={styles.modalItemContainer}
                    onPress={() => navForgotPsd(2)}
                    textStyle={styles.modalText}
                    text={Str_PhoneRetrieve}
                />}
                {boundEmail && <Line />}
                {boundEmail && <ButtonView
                    style={styles.modalItemContainer}
                    onPress={() => navForgotPsd(3)}
                    textStyle={styles.modalText} text={Str_EmailRetrieve}
                />}
                <View style={{ backgroundColor: "#F7F7F7", height: 6 }} />
                <ButtonView
                    style={styles.modalItemContainer}
                    onPress={dismiss}
                    textStyle={styles.modalText}
                    text={Str_Cancel}
                />
            </SafeAreaView>
        </TouchableOpacity>
    </Modal>);
}

const styles = StyleSheet.create({
    modalContainer: {
        position: "absolute",
        width: "100%",
        backgroundColor: "white",
        borderTopEndRadius: 15,
        borderTopStartRadius: 15,
        bottom: 0
    },
    modalItemContainer: {
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: 16
    },
    modalText: {
        fontSize: 18,
        color: color_333333
    },

})